import { dto_common } from "../../classes/dto-common";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { Font } from "../../util/config-fonts";
import "../../styles/css/pg-cart-itemList.css";
import { Colors } from "../../util/colors";
import { FORMAT_DECIMAL_VALUE } from "../../functions/funtion";
import { CSP } from "../../config/config";
import { buildEncryptedValueProps } from "../../functions/store_sessions";

function CartItemList({
  item,
  index,
  NavigateToProductPage,
  RemoveItemFromCart,
}) {
  if (item.ProductImageUrl === "" ) {
    if (CSP === "AV") {
      item.ProductImageUrl = "https://www.daitonnmail.com/avas_images/15.jpg";
    } else {
      item.ProductImageUrl = dto_common.DefaultImageUrl;
    }
  }
  var DESCRIPTION = "";
  if (item.Desc.includes("μ")) {
    DESCRIPTION = item.Desc.substring(item.Desc.lastIndexOf("μ"), 0);
  } else {
    DESCRIPTION = item.Desc;
  }

  var descriptionWarning = item.Desc.split("μ");
  const modification = item.Modification || "";
  const splitByNoteDelimiter = modification.split("µµ");
  const addOnRaw = splitByNoteDelimiter[0] || "";
  const noteAndMeta = splitByNoteDelimiter[1] || "";
  const itemNote = noteAndMeta.split("µ")[0] || "";
  const addOnDesc = addOnRaw
    .split("|")
    .filter((entry) => entry !== "")
    .map((entry) =>
      entry.includes("¥") ? entry.substring(0, entry.lastIndexOf("¥")) : entry,
    )
    .join(", ");

  const grossLineAmount =
    parseFloat(item.UP) * parseFloat(item.Qty) + parseFloat(item.ExtraCost);
  const netLineAmount =
    (parseFloat(item.UP) - parseFloat(item.UD)) * parseFloat(item.Qty);

  if (item.TID !== 5) {
    return (
      <div
        className="itemListLayout fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        <div className="itemListRowLG">
          <div
            className="itemListRowText"
            onClick={() => {
              NavigateToProductPage(item);
            }}
            style={{ cursor: "pointer" }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "13px",
              }}
            >
              {DESCRIPTION}
            </p>
            {addOnDesc.length > 0 ? (
              <p
                style={{
                  fontSize: Font.Description,
                  fontStyle: "italic",
                  margin: 0,
                }}
              >
                {addOnDesc}
              </p>
            ) : null}
            {itemNote.length > 0 ? (
              <p
                style={{
                  fontSize: Font.Description,
                  margin: 0,
                  fontStyle: "italic",
                }}
              >
                {itemNote}
              </p>
            ) : null}
            {descriptionWarning[1] !== undefined ? (
              <p
                style={{
                  color: "orange",
                  fontSize: Font.Description,
                  margin: 0,
                }}
              >
                {descriptionWarning[1]}
              </p>
            ) : null}

            {item.UD > 0 ? (
              <div style={{ display: "flex" }}>
                <p
                  style={{
                    paddingTop: 0,
                    marginTop: "4px",
                    marginBottom: "4px",
                    fontSize: Font.Amount,
                    color: "red",
                    alignSelf: "stretch",
                    textDecorationLine: "line-through",
                    textDecorationStyle: "solid",
                    marginRight: 5,
                  }}
                  {...buildEncryptedValueProps(grossLineAmount)}
                >
                  {dto_StartupPageLoadInfo.Currency}
                  {"  "}
                  {FORMAT_DECIMAL_VALUE(
                    2,
                    grossLineAmount,
                    2,
                  )}
                </p>
                <p
                  style={{
                    paddingTop: 0,
                    color: Colors.ThemeBGcolor,
                    marginTop: "4px",
                    marginBottom: "4px",
                    fontSize: Font.Amount,
                  }}
                  {...buildEncryptedValueProps(netLineAmount)}
                >
                  {dto_StartupPageLoadInfo.Currency}
                  {"  "}
                  {FORMAT_DECIMAL_VALUE(
                    2,
                    netLineAmount,
                    2,
                  )}
                </p>
              </div>
            ) : (
              <p
                style={{
                  fontSize: Font.Amount,
                  margin: 0,
                  color: "black",
                  fontWeight: "bold",
                }}
                {...buildEncryptedValueProps(grossLineAmount)}
              >
                {dto_StartupPageLoadInfo.Currency}{" "}
                {grossLineAmount
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
              </p>
            )}
          </div>

          <div
            className="itemListRowText"
            style={{ cursor: "pointer" }}
            onClick={() => {
              NavigateToProductPage(item);
            }}
          >
            <img
              src={item.ProductImageUrl}
              onError={(e) => {
                e.currentTarget.src = dto_common.DefaultImageUrl;
              }}
              alt=""
            />
          </div>

          <div
            className="itemListRowText"
            style={{ cursor: "pointer" }}
            onClick={() => {
              NavigateToProductPage(item);
            }}
          >
            <p style={{ textAlign: "center" }}> {item.Qty}</p>
          </div>
          {CSP === "AV" && item.PID === 1224929 ? (
            ""
          ) : (
            <div
              style={{
                display: "flex",
                borderStyle: "none",
                marginRight: 5,
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                RemoveItemFromCart(index, item.LineID, item.ADDONLINEID, item);
              }}
            >
              <button
                style={{
                  border: 0,
                  background: "none",
                  color: "black",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                <i className="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default CartItemList;
